import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-start",
  "use": "icon-icon-start-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-start\">\r\n  <defs>\r\n    <style type=\"text/css\"></style>\r\n  </defs>\r\n  <path d=\"M923.427 494.115c0 0-425.517-248.001-659.388-384.303-58.407-35.322-149.748-77.699-149.748 71.567 0 191.617 0 508.64 0 674.874 2.115 84.837 64.329 68.545 103.814 48.91 218.391-127.274 705.325-411.050 705.325-411.050z\" fill=\"#ffffff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol